import { render, staticRenderFns } from "./AtencionTerapias.vue?vue&type=template&id=e3d0a882"
import script from "./AtencionTerapias.vue?vue&type=script&lang=js"
export * from "./AtencionTerapias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports